import React from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { Camera } from '@olxbr/ds-icons';
import Video from './Video';
import * as Styles from './styles';
export const AdMediaCounter = _ref => {
  let {
    currentImage,
    imagesCount,
    currentVideo,
    videosCount,
    hideNumbers = false,
    hideIcons = false
  } = _ref;
  const imageCountLabel = currentImage ? "".concat(currentImage, " / ").concat(imagesCount) : imagesCount;
  const videoCountLabel = currentVideo ? "".concat(currentVideo, " / ").concat(videosCount) : videosCount;
  const showVideoIcon = hideNumbers && videosCount;
  if (!imagesCount && !videosCount) {
    return React.createElement(React.Fragment, null);
  }
  return React.createElement(Styles.AdMediaCounterWrapper, {
    "data-ds-component": "DS-AdMediaCounter"
  }, !!imagesCount && React.createElement("div", null, !hideIcons && !showVideoIcon && React.createElement("div", {
    "data-testid": "camera-icon"
  }, React.createElement(Camera, {
    size: 16
  })), !hideNumbers && React.createElement("span", {
    "aria-label": "Quantidade de fotos: ".concat(imagesCount)
  }, imageCountLabel)), !!videosCount && React.createElement("div", null, !hideIcons && React.createElement("div", {
    "data-testid": "video-icon"
  }, React.createElement(Video, {
    size: 16
  })), !hideNumbers && React.createElement("span", {
    "aria-label": "Quantidade de v\xEDdeos: ".concat(videosCount)
  }, videoCountLabel)));
};
AdMediaCounter.displayName = 'AdMediaCounter';